export const sideModal = {
  active: "Ativo"
};
